import React from 'react';
// nodejs library to set properties for components

class ProgressBar extends React.Component {
  render() {
    const total = this.props.total ? this.props.total : 20;

    const progressStyle = {
      width: `${(this.props.progress / total) * 100}%`,
    };
    const reviewText =
      this.props.review === 1
        ? `Reviewing Question ${this.props.progress} of ${total}`
        : `${this.props.progress} of ${total} Questions`;
    return (
      <div className="progress-wrapper">
        {this.props.title === true ? <h4>{reviewText}</h4> : null}
        <div className="progress-bar">
          <div className="progress-inside" style={progressStyle} />
        </div>
      </div>
    );
  }
}

export default ProgressBar;
